import React from 'react';
import './Footer.css';
import { useTranslationContext } from '../../contexts/TranslationContext';
import useAutoTranslate from '../../hooks/useAutoTranslate';
import fr from './langue/fr.json';
import en from './langue/en.json';
import { FaLinkedin, FaEnvelope } from 'react-icons/fa';

function Footer() {
  const t = useAutoTranslate({ fr, en });

  return (
    <footer className="footer">
      <div className="footer__container">
        <p>{t('copyright')}</p>
        <div className="footer__links">
          <a href="https://www.linkedin.com/in/baptiste-lemattre" target="_blank" rel="noreferrer" aria-label="LinkedIn">
            <FaLinkedin />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;